<template>
  <div class="field has-addons">
    <div class="control has-icons-right">
      <input type="text"
             data-input
             class="input"
             :placeholder="placeholder"
             :name="name"
             :value="value"
             @input="emit"
      />
      <span class="icon is-small is-right"><i class="fa fa-calendar"></i></span>
    </div>
    <button type="button" class="button is-transparent has-text-gray-300" data-clear @click.prevent=""
            v-show="value">
      <i class="fa fa-times text-muted"></i>
    </button>
  </div>
</template>
<script type="text/babel">
import flatpickr from "flatpickr";
import {Thai} from "flatpickr/dist/l10n/th.js"

flatpickr.localize(Thai);

export default {
  data() {
    return {
      calendar: null,
      options: {
        altInput: true,
        altFormat: "j M Y",
        required: true,
        wrap: true,
        minDate: this.minDate,
        onValueUpdate(date, value, flat) {
          if (value === null || value === '') {
            return;
          }

          date = moment(value);
          flat.altInput.value = date.format('D MMMM ') +
              (parseInt(date.format('YYYY')) + 543);
        },
        onReady(date, value, flat) {
          if (value === '') {
            return '';
          }
          date = moment(value);
          flat.altInput.value = date.format('D MMMM ') +
              (parseInt(date.format('YYYY')) + 543);
        }
      }
    }
  },
  props: {
    value: {'default': null},
    placeholder: {type: String, 'default': null},
    name: {type: String, 'default': null},
    required: {type: Boolean, required: false, 'default': false},
    minDate: {type: String, required: false, 'default': null},
  },
  watch: {
    minDate() {
      this.calendar.set('minDate', this.minDate);
    }
  },

  mounted() {
    this.calendar = flatpickr(this.$el, this.options);
  },

  methods: {
    emit($event) {
      this.$emit('input', $event.target.value);
      this.$emit('change', $event.target.value);
    },
    setDate(date) {
      this.calendar.setDate(date);
    }
  }
}
</script>
